export  function frontpageFix() {
    if(navigator.userAgent.indexOf("Chrome") > -1 || navigator.userAgent.indexOf("Safari") > -1){
        let options2 = {
            root: document.querySelector('#scrollArea'),
            rootMargin: '34%',
            threshold: 1
        }
    
        let callback2 = (entries, observer) => {
            if(entries[0].intersectionRatio!=1){
                entries[0].target.parentElement.style.position = "absolute"
                observer.unobserve(entries[0].target);
            }
        };
    
        
        let observer2 = new IntersectionObserver(callback2, options2);
        const target2 = document.querySelector('#maonb-name');
        observer2.observe(target2);
    }
}